var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.071.313H1.93C.864.313 0 1.194 0 2.28V16.72c0 1.087.864 1.968 1.929 1.968H16.07c1.065 0 1.929-.881 1.929-1.968V2.28c0-1.087-.864-1.969-1.929-1.969zm.643 16.406c0 .36-.289.656-.643.656H1.93a.652.652 0 01-.643-.656V2.28c0-.36.289-.656.643-.656H16.07c.354 0 .643.295.643.656V16.72zM13.018 5.562H9v-1.64a.977.977 0 00-.964-.985H6.107a.977.977 0 00-.964.985v1.64H3.696a.489.489 0 00-.482.493v.328c0 .27.217.492.482.492h1.447v1.64c0 .542.434.985.964.985h1.929c.53 0 .964-.443.964-.984V6.875h4.018a.489.489 0 00.482-.492v-.328a.489.489 0 00-.482-.492zM7.714 8.188H6.43V4.25h1.285v3.938zm5.947 3.938h-.804v-1.64a.977.977 0 00-.964-.985H9.964a.977.977 0 00-.964.984v1.641H4.34a.489.489 0 00-.483.492v.328c0 .271.217.492.482.492H9v1.641c0 .542.434.985.964.985h1.929c.53 0 .964-.443.964-.985v-1.64h.804a.489.489 0 00.482-.493v-.328a.489.489 0 00-.482-.492zm-2.09 2.625h-1.285v-3.938h1.285v3.938z",
    fill: "#3555F0"
  })));
}

export default __webpack_public_path__ + "./fonts/static.e2d50b97bbce4c56b922e65f84a50f0d.svg";
export { SvgStatic as ReactComponent };